export default {
  computed: {
    getLabelTitleErrorMessage() {
      let errorMessage = '';
      if (!this.$v.title.$error) {
        errorMessage = '';
      } else if (!this.$v.title.required) {
        errorMessage = this.$t('LABEL_MGMT.FORM.NAME.REQUIRED_ERROR');
      } else if (!this.$v.title.minLength) {
        errorMessage = this.$t('LABEL_MGMT.FORM.NAME.MINIMUM_LENGTH_ERROR');
      } else if (!this.$v.title.validLabelCharacters) {
        errorMessage = this.$t('LABEL_MGMT.FORM.NAME.VALID_ERROR');
      }
      return errorMessage;
    },
  },
  methods: {
    getTriggerBeforeErrorMessage(index) {
    const field = this.$v.dataList.$each[index]?.trigger_before;
    if (!field || !field.$error) return '';

    if (!field.required) {
      return this.$t('LABEL_MGMT.FORM.TRIGGEREDBEFORE.REQUIRED_ERROR');
    }
    if (!field.positiveNaturalNumber) {
      return this.$t('LABEL_MGMT.FORM.TRIGGEREDBEFORE.NUMERIC_ERROR');
    }

    return '';
  },
  getMacroIdErrorMessage(index) {
    const field = this.$v.dataList.$each[index]?.macro_id;
    if (!field || !field.$error) return '';

    if (!field.required) {
      return this.$t('LABEL_MGMT.FORM.MACRO.REQUIRED_ERROR');
    }
    if (!field.numeric) {
      return this.$t('LABEL_MGMT.FORM.MACRO.NUMERIC_ERROR');
    }

    return '';
  },
  getAutomationErrorMessage(index) {
    const field = this.$v.dataList.$each[index]?.is_before;
    if (!field || !field.$error) return '';

    if (!field.required) {
      return this.$t('LABEL_MGMT.FORM.AUTOMATION.REQUIRED_ERROR');
    }

    return '';
  },
  getContactAutomationInboxErrorMessage() {
    const field = this.$v.contactAutomationData?.inbox_id;
    if (!field || !field.$error) return '';
    if (!field.required) {
      return this.$t('LABEL_MGMT.FORM.INBOX.REQUIRED_ERROR');
    }
    if (!field.numeric) {
      return 'Only numeric values are allowed';
    }
    return '';
  },
  getContactAutomationLabelErrorMessage() {
    const field = this.$v.contactAutomationData?.label_id;
    if (!field || !field.$error) return '';
    if (!field.required) {
      return this.$t('LABEL_MGMT.FORM.CONTACT_AUTOMATION_LABEL.REQUIRED_ERROR');
    }
    return '';
  },
  }
};
